exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-label[data-v-6066a3a0]{width:30%}.file-input-error[data-v-6066a3a0]{color:#dc3545;position:absolute;margin-top:2rem}.image-preview[data-v-6066a3a0]{z-index:1}.characters[data-v-6066a3a0]{width:70%!important}", ""]);

// exports
